import React from "react";
import classnames from "classnames";

import { RefluxComponent } from "sp-react-commons";
import PostActions from "../../actions/PostActions";
import PostStore from "../../stores/PostStore";
import LatestPosts from "./LatestPosts";


import Translation from "../../../commons/i18n/Translation";

/**
 * MyWort home page section 2 tabs for switching between News and Events.
 *
 *
 */
export class LandingTabs extends RefluxComponent {

    constructor(props) {
        super(props);
        this.state = this.getInitialState(props);
    }

    updateQueryStringParam(key, value) {
        var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            newParam = key + '=' + value,
            params = '?' + newParam;

        if (urlQueryString) {
            let keyRegex = new RegExp('([\?&])' + key + '[^&]*');
            if (urlQueryString.match(keyRegex) !== null) {
                params = urlQueryString.replace(keyRegex, "$1" + newParam);
            } else {
                params = urlQueryString + '&' + newParam;
            }
        }
        return baseUrl + params;
    }

    getInitialState = () => {
        let activeTab = this.props.activeTab  || 'post';
        if(this.props.activeTab !== 'post' && this.props.activeTab !== 'event' && this.props.activeTab !== 'locality' && this.props.activeTab !== 'group'){
            activeTab = 'post'
        }
        return {
            activeTab: activeTab,
            posts: PostStore.posts,
            events: PostStore.events,
            localities: PostStore.localities,
            groups: PostStore.groups,
            remainingPosts: PostStore.remainingPosts,
            remainingEvents: PostStore.remainingEvents,
            remainingGroups: PostStore.remainingGroups,
            remainingLocalities: PostStore.remainingLocalities
        }
    };

    componentDidMount() {
        this.listenTo(PostStore, this.onStoreChange);
    }

    onStoreChange = () => {
        this.setState({
            posts: PostStore.posts,
            events: PostStore.events,
            localities: PostStore.localities,
            groups: PostStore.groups,
            remainingPosts: PostStore.remainingPosts,
            remainingEvents: PostStore.remainingEvents,
            remainingGroups: PostStore.remainingGroups,
            remainingLocalities: PostStore.remainingLocalities
        });

    };

    switchToTab = (e, tab) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            activeTab : tab
        });
        history.pushState({}, document.title, this.updateQueryStringParam("activeTab", tab));
    };

    getActiveTab = () => {
        return this.state.activeTab;
    };

    onClickMoreEvents = () => {
        PostActions.getMoreEvents();
    };


    onClickMorePosts = () => {
        PostActions.getMorePost();
    };

    onClickMoreGroups = () => {
        PostActions.getMoreGroups();
    };

    onClickMoreLocalities = () => {
        PostActions.getMoreLocalities();
    };

    onRedirectToSearch = () => {
        if(this.state.activeTab==='locality' || 'group') window.location = '/' + Translation.getLanguageName() + '/mywort/search';
        else window.location = '/' + Translation.getLanguageName() + '/mywort/search#/?type=' + this.state.activeTab;
    };

    render = () => {
        return <LandingTabsPresenter
                activeTab={this.getActiveTab()}
                posts={this.state.posts}
                events={this.state.events}
                localities={this.state.localities}
                groups={this.state.groups}
                switchToTab={this.switchToTab}
                canLoadMorePosts={this.state.remainingPosts > 0}
                onLoadMorePosts={this.onClickMorePosts}
                canLoadMoreEvents={this.state.remainingEvents > 0}
                onLoadMoreEvents={this.onClickMoreEvents}
                canLoadMoreGroups={this.state.remainingGroups > 0}
                onLoadMoreGroups={this.onClickMoreGroups}
                canLoadMoreLocalities={this.state.remainingLocalities > 0}
                onLoadMoreLocalities={this.onClickMoreLocalities}
                onRedirectToSearch={this.onRedirectToSearch}
            />
    }
}


export class LandingTabsPresenter extends React.Component {

    renderTab = (tabName) => (
        <li className={ classnames("mywort-section-navigation__entry", { "mywort-section-navigation__entry--active": this.props.activeTab === tabName }) }>
            <a href="#" onClick={(e) => this.props.switchToTab(e, tabName)}>
                <h2 className="mywort-section-navigation__inherit">
                    {Translation.translate("landing.tabs." + tabName + "s")}
                </h2>
            </a>
        </li>
    );

    renderInfoBox = (tabName) => (
        <div className="pure-u-1 mywort-info-box">
            <div className="mywort-info-box__message">
                {Translation.translate("landing.info-box." + tabName + "-message")}
            </div>
        </div>
    );

    render = () => {
        return <div>
            <div className="section__header">
                <ul className="mywort-section-navigation">
                    { this.renderTab("post") }
                    { this.renderTab("event") }
                    { this.props.localities.length > 0 ? this.renderTab("locality") : null }
                    { this.props.groups.length > 0 ? this.renderTab("group") : null }
                </ul>
            </div>
            <div id="mywort-react-posts" className={classnames({ "hide": this.props.activeTab !== 'post' })}>
                <LatestPosts
                    elements={this.props.posts}
                    canShowMore={this.props.canLoadMorePosts}
                    onClickMore={this.props.onLoadMorePosts}
                    onClickSearch={this.props.onRedirectToSearch}/>
            </div>
            <div id="mywort-react-events" className={classnames({ "hide": this.props.activeTab !== 'event' })}>
                <LatestPosts
                    elements={this.props.events}
                    canShowMore={this.props.canLoadMoreEvents}
                    onClickMore={this.props.onLoadMoreEvents}
                    onClickSearch={this.props.onRedirectToSearch}/>
            </div>
            { this.props.localities.length > 0 ?
            <div id="mywort-react-localities" className={classnames("pure-g pure-g--gutters-mywort card-block", { "hide": this.props.activeTab !== 'locality' })}>
                {this.renderInfoBox('locality')}
                {this.props.localities.map(locality =>
                    <div className="card-block__column pure-u-1 pure-u-lg-12-24 pure-u-md-24-24" key={locality.id}>
                        <article className="mywort-post mywort-post--full-condensed">
                            <div className="mywort-post__locality__container">
                                <div className="mywort-post__title-inside mywort-post__title-inside--locality">
                                    <a className="mywort-post__title-inside__locality-name" href={locality.permalink}>{locality.name}</a>
                                    <div className="mywort-post__title-inside__municipality">
                                        { locality.name!==locality.municipality ?
                                            Translation.translate("search.filters.municipality") + " " + locality.municipality
                                            : null
                                        }
                                    </div>
                                </div>
                                <a className="mywort-post__picture-wrapper mywort-post__link mywort-post__picture-wrapper--locality" href={locality.permalink}>
                                    <img className="mywort-post-localities__img" src={locality.pictureUrl}/>
                                </a>
                            </div>
                        </article>
                    </div>
                )}
                <div className="pure-u-1 card-block__row card-block__row--center">
                    {this.props.canLoadMoreLocalities ? (
                        <button id="mywort-btn mywort-btn__locality__more" className="mywort-btn mywort-btn__locality u-mr-h" onClick={this.props.onLoadMoreLocalities}>
                            {Translation.translate("public.more")}
                        </button>
                    ) : null}
                    <button id="mywort-btn mywort-btn__locality__search"  className="mywort-btn mywort-btn__locality mywort-btn--outlined-orange" onClick={this.props.onRedirectToSearch}>
                        {Translation.translate("public.search")}
                    </button>
                </div>
            </div>
                : null }
            { this.props.groups.length > 0 ?
            <div id="mywort-react-groups" className={classnames("pure-g pure-g--gutters-mywort card-block", { "hide": this.props.activeTab !== 'group' })}>
                {this.renderInfoBox('group')}
                {this.props.groups.map(group =>
                    <div className="card-block__column pure-u-1 pure-u-lg-12-24 pure-u-md-24-24" key={group.name}>
                        <article className="mywort-post mywort-post--full-condensed">
                            <div className="mywort-post__locality__container">
                                <div className="mywort-post__title-inside mywort-post__title-inside--group">
                                    <a className="mywort-post__title-inside__group-name" href={group.permalink}>{group.name}</a>
                                    <a className="mywort-post__title-inside__municipality" href={group.localityPermalink}>{group.localityName}</a>
                                </div>
                                <a className="mywort-post__picture-wrapper mywort-post__link mywort-post__picture-wrapper--group" href={group.permalink}>
                                    <img className="mywort-post-group__img" src={group.pictureUrl}/>
                                </a>
                            </div>
                        </article>
                    </div>
                )}
                <div className="pure-u-1 card-block__row card-block__row--center">
                    {this.props.canLoadMoreGroups ? (
                        <button id="mywort-btn__group__more" className="mywort-btn mywort-btn__group u-mr-h" onClick={this.props.onLoadMoreGroups}>
                            {Translation.translate("public.more")}
                        </button>
                    ) : null}
                    <button id="mywort-btn__group__search" className="mywort-btn mywort-btn__group mywort-btn--outlined-orange" onClick={this.props.onRedirectToSearch}>
                        {Translation.translate("public.search")}
                    </button>
                </div>
            </div>
                : null }
        </div>
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/post/LandingTabs.jsx